document.addEventListener('DOMContentLoaded', () => {
  const initLookbookVideo = () => {
    const sliderEl = document.querySelector(
      '.lookbook-video-main .swiper'
    );

    if (!sliderEl || !sliderEl.swiper) {
      setTimeout(initLookbookVideo, 300);
      return;
    }

    const swiper = sliderEl.swiper;

    swiper.on('slideChangeTransitionStart', () => {
      resetInactiveSlides(swiper);
    });

    resetInactiveSlides(swiper);
  };

  initLookbookVideo();
});

function resetInactiveSlides(swiper) {
  swiper.slides.forEach((slide) => {
    if (slide.classList.contains('swiper-slide-active')) {
      return;
    }

    const deferredMedia = slide.querySelector('deferred-media');

    if (!deferredMedia) return;

    /*
      Pause native video
    */
    const video = deferredMedia.querySelector('video');

    if (video) {
      video.pause();

      try {
        video.currentTime = 0;
      } catch (e) {}
    }

    /*
      Remove youtube/vimeo iframe
    */
    deferredMedia.querySelectorAll('iframe').forEach((iframe) => {
      iframe.remove();
    });

    /*
      Remove native video
    */
    deferredMedia.querySelectorAll('video').forEach((video) => {
      video.remove();
    });

    /*
      Reset trạng thái deferred-media
    */
    deferredMedia.removeAttribute('loaded');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const timer = setInterval(() => {
    const swiperEl = document.querySelector(
      '.lookbook-video-main .swiper'
    );

    if (!swiperEl?.swiper) return;

    clearInterval(timer);

    const swiper = swiperEl.swiper;

    swiper.slides.forEach((slide) => {
      slide.addEventListener('click', () => {
        if (slide.classList.contains('swiper-slide-active')) return;

        const realIndex =
          slide.getAttribute('data-swiper-slide-index');

        swiper.slideToLoop(Number(realIndex));
      });
    });
  }, 200);
});